module.exports = __webpack_public_path__ + "static/media/machine-trainers.3d489d8b.obj";